import React from 'react';
import { MailIcon, InstagramIcon, GlobeIcon } from 'lucide-react';
export function Footer() {
  return <footer className="border-t border-white/10 bg-ink" data-id="element-63" data-mp="3gfitaf6445cj">
      <div className="mx-auto max-w-4xl px-5 pt-[28px] pb-14 text-center" style={{
      paddingBottom: "25px"
    }} data-id="element-64" data-mp="3gh3sii3dgcgq">
        <p className="font-display text-xl font-black text-white" data-id="element-65" data-mp="36pfufycb7x6a">
          MasterPack Marca Propia Argentina<span className="align-super text-xs" data-id="element-66" data-mp="3uf0md6qfy4rp">™</span>
        </p>
        <p className="mx-auto mt-3 max-w-xl text-sm leading-relaxed text-white/60" data-id="element-67" data-mp="3uftkjjbc3ly8">
          El sistema de lanzamiento de marcas de indumentaria N°1 para emprendedores de Argentina.
          Porque invertir en ropa no debería costarte todos tus ahorros.
        </p>

        <div className="mt-8 flex flex-wrap items-center justify-center gap-x-6 gap-y-3 text-sm text-white/70" data-id="element-68" data-mp="3qcduj5trsjui">
          <a href="mailto:soporte.sigmasmart@gmail.com" className="inline-flex items-center gap-2 transition-colors hover:text-gold" data-id="element-69" data-mp="29xlz0k1buwgz">
            <MailIcon className="h-4 w-4 text-celeste" data-id="element-70" data-mp="2evxb71f3hj2d" /> soporte.sigmasmart@gmail.com
          </a>
          <a href="#" className="inline-flex items-center gap-2 transition-colors hover:text-gold" data-id="element-71" data-mp="3lbdc0r0ka5kr">
            <InstagramIcon className="h-4 w-4 text-celeste" data-id="element-72" data-mp="3gctmyhqo8do6" /> @sigmasmartoficial
          </a>
          <a href="#" className="inline-flex items-center gap-2 transition-colors hover:text-gold" data-id="element-73" data-mp="3v5dfypk3x4rw">
            <GlobeIcon className="h-4 w-4 text-celeste" data-id="element-74" data-mp="3qazqf3s4lrv5" /> www.sigmasmart.store
          </a>
        </div>

        <p className="mt-4 font-display text-base italic text-gold" style={{
        fontSize: "18px"
      }} data-id="element-75" data-mp="33xefz77o0t1">
          “Tu primera cápsula de ropa
empieza acá.” 👕
        </p>

        <div className="mt-8 flex flex-wrap justify-center gap-x-4 gap-y-2 text-xs text-white/40" data-id="element-76" data-mp="hs1yb6i02ide">
          <a href="#" className="transition-colors hover:text-white/70" data-id="element-77" data-mp="cuiku8t4m9mi">
            Términos y condiciones
          </a>
          <span data-id="element-78" data-mp="qr5gm89cetqu">·</span>
          <a href="#" className="transition-colors hover:text-white/70" data-id="element-79" data-mp="ms6d8s39f51i">
            Política de privacidad
          </a>
          <span data-id="element-80" data-mp="tw5yi6q9bqmq">·</span>
          <a href="#" className="transition-colors hover:text-white/70" data-id="element-81" data-mp="two43tyt7h7b">
            Soporte
          </a>
        </div>

        <p className="mt-8 text-xs leading-relaxed text-white/35" data-id="element-82" data-mp="ys3ay1yegcu8">
          © 2026 MasterPack Marca Propia Argentina™ — Todos los derechos reservados. Prohibida la
          reproducción y redistribución sin autorización expresa.
        </p>
      </div>
    </footer>;
}